import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from '../firebase/config';
import "./Login.css"

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isPending, setIsPending] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const oobCode = searchParams.get('oobCode'); // Get the code from the URL

    if (!oobCode) {
      setError('Invalid or missing code.');
      return;
    }

    setError('');
    setIsPending(true);

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setMessage('Password has been successfully reset.');
      navigate('/login');
    } catch (err) {
      setError('Failed to reset password. Please try again.');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="reset-container">
      <h2>Reset Password</h2>
      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleResetPassword}>
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={isPending}>
          {isPending ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
    </div>
  );
}